// packages/web/src/components/onboarding/onboarding-password-form.tsx
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export interface OnboardingPasswordFormProps {
  isPending: boolean;
  onSubmit: (password: string) => Promise<void>;
}

export function OnboardingPasswordForm({ isPending, onSubmit }: OnboardingPasswordFormProps) {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit() {
    if (password.length < 12) {
      setError(t("onboarding.password-form.errors.too-short"));
      return;
    }
    setError(null);
    try {
      await onSubmit(password);
    } catch (e) {
      const message =
        typeof e === "object" && e && "message" in e
          ? String((e as { message: unknown }).message)
          : "";
      setError(message || t("onboarding.password-form.errors.unknown"));
    }
  }

  return (
    <div className="mx-auto max-w-md space-y-3 p-6">
      <div className="space-y-1.5">
        <Label htmlFor="opw">{t("onboarding.password-form.password.label")}</Label>
        <Input
          id="opw"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          aria-invalid={!!error}
        />
        {error ? <p className="text-[12px] text-vroom-red">{error}</p> : null}
      </div>
      <Button variant="primary" className="w-full" onClick={handleSubmit} disabled={isPending}>
        {t("onboarding.password-form.submit.label")}
      </Button>
    </div>
  );
}
